import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aac51e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collecting" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "UserManagement-table" }
const _hoisted_4 = { class: "paginationCont" }

import { reactive, ref, onMounted, onUnmounted, nextTick, watch } from "vue";
import { ElMessage, ElPopconfirm, ElMessageBox } from "element-plus";
import { Search, RefreshRight, CirclePlus } from "@element-plus/icons-vue";
import { getDeptTree, groupInfoDelete, groupInfoList } from "./api.js";
import CreateCollectiveDialog from './views/CreateCollectiveDialog.vue';
import EditCollectiveDialog from './views/EditCollectiveDialog.vue';
import CollectiveMembersDialog from './views/CollectiveMembersDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);
const calculating = ref(false);
const hasCalculated = ref(false);

const calculateTableRows = () => {
    if (calculating.value) return;
    calculating.value = true;

    const tableContainer = document.querySelector('.UserManagement-table');
    if (!tableContainer) {
        calculating.value = false;
        return;
    }

    const allRows = document.querySelectorAll('.el-table__row');
    if (!allRows.length) {
        if (!hasInitialSearch.value) {
            hasInitialSearch.value = true;
            onSearch(false);
        }
        calculating.value = false;
        return;
    }

    // 计算所有行的平均高度
    const totalHeight = Array.from(allRows).reduce((sum, row) => {
        return sum + row.getBoundingClientRect().height;
    }, 0);
    const averageRowHeight = totalHeight / allRows.length;
    
    const tableHeader = document.querySelector('.el-table__header');
    const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
    
    const containerHeight = tableContainer.clientHeight;
    const availableHeight = containerHeight - headerHeight;
    
    // 计算可显示的行数
    const maxRows = Math.floor((availableHeight - 20) / averageRowHeight);
    
    // 向上取整到最近的5的倍数
    const calculatedSize = Math.ceil(maxRows / 5) * 5;

    // 添加合理的最小值和最大值限制
    const minPageSize = 5;
    const maxPageSize = 50;
    const normalizedSize = Math.min(Math.max(calculatedSize, minPageSize), maxPageSize);

    const tolerance = 2;
    if (Math.abs(queryForm.pageSize - normalizedSize) <= tolerance) {
        calculating.value = false;
        return;
    }

    console.log('计算得到的行数---:', {
        containerHeight,
        headerHeight,
        availableHeight,
        averageRowHeight,
        maxRows,
        calculatedSize: normalizedSize
    });

    pageSizes.value = [normalizedSize, normalizedSize * 2, normalizedSize * 3].filter(size => size <= maxPageSize);
    defaultPageSize.value = normalizedSize;
    queryForm.pageSize = normalizedSize;
    
    setTimeout(() => {
        onSearch(true);
        calculating.value = false;
    }, 100);
};
const defaultPageSize = ref(10);

const queryForm = reactive({
    pageIndex: 1,
    pageSize: defaultPageSize.value,
    condition: {
        groupName: '',
        farmerName: '',
        idCard: ''
    },
});

const total = ref<number>(0);
const tableData = ref<any>([]);
const deptTree = ref<any>([]);
const createDialogVisible = ref(false);
const membersDialogVisible = ref(false);
const currentCollectiveId = ref('');
const queryFormRef = ref();


const onSearch = (type: boolean) => {
    // 创建一个新的查询对象，移除空字符串值和null值
    const cleanQuery = Object.fromEntries(
        Object.entries(queryForm.condition).filter(([_, v]) => v !== "" && v !== null)
    );

    groupInfoList({ ...queryForm, condition: cleanQuery }).then((res: any) => {
            const { items, totalSize } = res;
            total.value = Number(totalSize);
            tableData.value = items;
            }).catch((error) => {
            console.error("Error fetching collar page:", error);
            ElMessage.error("获取数据失败，请重试");
        });
};
const handleReset = () => {
    hasCalculated.value = false;
    queryForm.condition.groupName = '';
    queryForm.condition.farmerName = '';
    queryForm.condition.idCard = '';
};

const handleSizeChange = (val: number) => {
    queryForm.pageSize = val;
    onSearch(true);
};
const handleCurrentChange = (val: number) => {
    queryForm.pageIndex = val;
    onSearch(false);
};

const editDialogVisible = ref(false);
const currentEditingCollective = ref({ id: '', groupName: '' });

const openEditDialog = (row) => {
    currentEditingCollective.value = {
        id: row.id || '',
        groupName: row.groupName || '',
        deptId: row.deptId || '',
        deptName: row.deptName || '' // 归属机构名字
    };
    editDialogVisible.value = true;
};

const handleUpdated = (updatedCollective) => {
    const index = tableData.value.findIndex(item => item.id === updatedCollective.id);
    if (index !== -1) {
        tableData.value[index] = { ...tableData.value[index], ...updatedCollective };
    }
    ElMessage.success('团体信息更新成功');
    onSearch(true);
};

const confirmDelete = (row: any) => {
    ElMessageBox.confirm(
        `确定删除该团体 "${row.groupName}" 吗？`,
        '删除确认',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        deleteItem(row);
    })
};

const deleteItem = (row: any) => {
    groupInfoDelete(row.id)
        .then(() => {
            ElMessage({
                type: 'success',
                message: '删除成功',
            });
            onSearch(true);
        })
};

const openCreateDialog = () => {
    createDialogVisible.value = true;
};

const handleCreated = () => {
    ElMessage.success('团体创建成功');
    onSearch(true);
};


const maintainMembers = (row: any) => {
    currentCollectiveId.value = row.id;
    membersDialogVisible.value = true;
};

const getDeptTreeFn = () => {
    getDeptTree().then((res: any) => {
        deptTree.value = res;
    });
};

onMounted(() => {
    nextTick(() => {
        calculateTableRows();
    });
    getDeptTreeFn();

    const debouncedCalculate = debounce(calculateTableRows, 200);
    window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0 && !hasCalculated.value) {
        nextTick(() => {
            calculateTableRows();
            hasCalculated.value = true;
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          inline: true,
          model: queryForm,
          class: "demo-form-inline",
          ref_key: "queryFormRef",
          ref: queryFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "团体名称" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.condition.groupName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.groupName) = $event)),
                      placeholder: "请输入",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "养殖户姓名" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.condition.farmerName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.farmerName) = $event)),
                      placeholder: "请输入",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "证件号码" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.condition.idCard,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.condition.idCard) = $event)),
                      placeholder: "请输入",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Search),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onSearch(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      type: "",
                      icon: _unref(RefreshRight),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(CirclePlus),
                      onClick: openCreateDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("创建团体")
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_table, {
          data: tableData.value,
          border: "",
          style: {"width":"100%"},
          height: "100%",
          onRowMounted: calculateTableRows
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "deptName",
              label: "机构",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "groupName",
              label: "团体名称",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created",
              label: "创建时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "creator",
              label: "创建人",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "280"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (maintainMembers(scope.row)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 维护团体成员 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (openEditDialog(scope.row)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (confirmDelete(scope.row)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 删除 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, sizes, prev, pager, next",
          "page-sizes": pageSizes.value,
          total: total.value,
          "current-page": queryForm.pageIndex,
          "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.pageIndex) = $event)),
          "page-size": queryForm.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.pageSize) = $event)),
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
      ])
    ]),
    _createVNode(CreateCollectiveDialog, {
      visible: createDialogVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((createDialogVisible).value = $event)),
      onCreated: handleCreated,
      deptTree: deptTree.value
    }, null, 8, ["visible", "deptTree"]),
    _createVNode(EditCollectiveDialog, {
      visible: editDialogVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((editDialogVisible).value = $event)),
      collective: currentEditingCollective.value,
      onUpdated: handleUpdated
    }, null, 8, ["visible", "collective"]),
    _createVNode(CollectiveMembersDialog, {
      visible: membersDialogVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((membersDialogVisible).value = $event)),
      collectiveId: currentCollectiveId.value
    }, null, 8, ["visible", "collectiveId"])
  ], 64))
}
}

})